import { APPLICATION_STATUSES } from "../../lib/applicationStatus";

export default function StatsGrid({ stats }) {
  const cards = [
    { key: "total", label: "Total", value: stats.total, testid: "stat-total", highlight: true },
    ...APPLICATION_STATUSES.map((s) => ({
      key: s,
      label: s,
      value: stats.by_status?.[s] ?? 0,
      testid: `stat-${s.replace(/\s+/g, "-").toLowerCase()}`,
    })),
  ];

  return (
    <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-6">
      {cards.map((c) => (
        <div
          key={c.key}
          data-testid={c.testid}
          className={`border p-5 ${
            c.highlight ? "border-[#D4AF37]/50 bg-[#0A1128]" : "border-white/10 bg-white/[0.02]"
          }`}
        >
          <div className="text-[10px] uppercase tracking-[0.28em] text-white/50">{c.label}</div>
          <div className="mt-2 font-serif text-3xl font-light text-white">{c.value}</div>
        </div>
      ))}
    </div>
  );
}
